import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="bg-blue-600 text-white p-4 shadow-lg">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-xl font-bold">Just right videos</h1>
        <div className="space-x-4">
          {/*<Link to="/multiple?videoIds=860027142,862503509,862254320,855607201" className="hover:text-blue-300">Multiple</Link>*/}
          {/*<Link to="/loop?videoIds=860027142,862503509,862254320,855607201" className="hover:text-blue-300">Loop</Link>*/}
          {/*<Link to="/videojs?videoIds=100,103,115" className="hover:text-blue-300">VideoJS</Link>*/}
          {/*<Link to="/videohls?videoIds=100,103,115" className="hover:text-blue-300">VideoJsWithHls</Link>*/}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
